import React,{useContext, useEffect, useState} from 'react'
import styled from 'styled-components'
import {ImAttachment} from 'react-icons/im'
import {HiOutlineDotsVertical} from 'react-icons/hi'
import {AiOutlinePlus} from 'react-icons/ai'
import {FaRegSmile} from 'react-icons/fa'
import {IoNavigate} from 'react-icons/io5'
import { db, useAuth } from '../firebase-config'
import Message from './Message'
import {
    collection,
    addDoc,
    Timestamp,
    setDoc,
    doc,
    updateDoc,
  } from "firebase/firestore"
import { ProductDetailContext } from '../context/ProductDetailsProvider'
import PrimaryBtn from './PrimaryBtn'
import FormInput from './FormInput'
import CustomModal from './CustomModal'
import { Link } from 'react-router-dom'

// send ref

function ChatDetailItem({ user, convo, secUser }) {
    const productContext = useContext(ProductDetailContext)
    let placeholderAvatar ="https://www.seekpng.com/png/detail/966-9665317_placeholder-image-person-jpg.png"
    const currentUser = useAuth()
    const [textMessage, setTextMessage] = useState(Object.keys(productContext.data).length  ? `Is ${productContext.data?.productDetails?.productName} Available ?`: "")
    const [currentEnqProduct, setCurrentEnqProduct] = useState(null)
    const user1 = currentUser?.uid
    const [showModal, setShowModal] = useState(false)
    const [newPrice, setNewPrice] = useState(0)
    const [newPriceSetPrg, setNewPriceSetPrg] = useState('Set Price')
  
    const handleSendMessage = async (e) => {
        e.preventDefault()

       let user2 = user.uid
       
        // const user2 = user.uid
        const id = user1> user2? `${user1+user2}` : `${user2 + user1}`
        await addDoc(collection(db, "messages", id, "chat"), {
            textMessage,
            from: user1,
            to: user2,
            createdAt: Timestamp.fromDate(new Date()),
          });
        setTextMessage('')
        // media: url || "",
    
        await setDoc(doc(db, "lastMsg", id), {
            textMessage,
            from: user1,
            to: user2,
            createdAt: Timestamp.fromDate(new Date()),
            unread: true,
          });
    }

   
    const filterEnquiryProducts = () => {
      const filtred=  convo.filter((item) => item.hasOwnProperty('enqProduct') )
      console.log(filtred[filtred.length - 1])
      setCurrentEnqProduct(filtred[filtred.length - 1])

    }


    
    
    console.log(productContext.user2Id)

    const handleEnquiryMessage = async (product) => {
        let user2 = productContext.user2Id
        const id = user1 > user2? `${user1+user2}` : `${user2 + user1}`
        if(user2){
            await addDoc(collection(db, "messages", id, "chat"), {
                enqProduct: product,
                docId: productContext.docId,
                from: user1,
                to: user2,
                createdAt: Timestamp.fromDate(new Date()),
              });
            setTextMessage('')
        }
        return
    }

   useEffect(() => {
     if(Object.keys(productContext.data).length && productContext.user2Id){
             handleEnquiryMessage(productContext.data)
             productContext.handleData({})
     }
   }, [currentUser?.uid, productContext.user2Id])

  



  const updateNewPrice = async (e) => {
      e.preventDefault()
      let user2 = user.uid
       
      // const user2 = user.uid
      const id = user1> user2? `${user1+user2}` : `${user2 + user1}`
      try {
        setNewPriceSetPrg('Updating...')
        await updateDoc(doc(db, "products", currentEnqProduct?.docId), {
            "productDetails.discountedPrice": newPrice,
        })
        // currentEnqProduct.enqProduct.productDetails.discountedPrice = newPrice
        await addDoc(collection(db, "messages", id, "chat"), {
            textMessage: 'New Price Updated please click on the product to view updated price',
            from: user1,
            to: user2,
            createdAt: Timestamp.fromDate(new Date()),
          });
        setNewPriceSetPrg("Set Price")
      } catch (error) {
        setNewPriceSetPrg("Set Price")
        console.log(error)
      }
  }

   useEffect(() => {
    filterEnquiryProducts()
   }, [convo])

   
   const ModalView = (
    <ModalWrap >
        <form onSubmit={updateNewPrice}>
      <label htmlFor="price">New Price</label>
      <FormInput value={newPrice} handleOnChange={(e) => setNewPrice(e.target.value)} type="number" inpName="new price" id="price"  />
      <div className="applybtn_cont">
      <button className="applybtn">
      {newPriceSetPrg}
    </button>
  </div>
        </form>
    </ModalWrap>
  )

   
    return (
        <ChatDetailWrap>
            <HorizontalChatOption>
            {showModal && 
            <CustomModal handleOnClick={() => setShowModal(false)}>
              {ModalView}
            </CustomModal>
                }
            <ChatPerson>
            <div className='chat_person'>
                    <img src={user?.personalInfo?.profilePic? user.personalInfo.profilePic : placeholderAvatar} alt="" />
                <div className='name_seen__box'>
                        <label className='chat_per_name'>{user?.personalInfo?.name}</label>
                    <label className='chat_last_seen'>{user?.lastSeen}</label>
                </div>

                </div>
            </ChatPerson>  
           {
               currentEnqProduct?.enqProduct?.shopId === `shop/${currentUser.uid}` &&
               <RecentEnqProduct>
               <div className="product_container">
               <Link className="link"  to={`/productdetail/:${currentEnqProduct?.docId}`} >
                <div className="product_img_cont">
                       <img src={currentEnqProduct?.enqProduct?.productPhoto} alt="" />
                   </div>
                   <div className="product_det">
                   <span className='price'>{currentEnqProduct?.enqProduct?.productDetails?.productName}</span>
                   <span className='product_name'>{currentEnqProduct?.enqProduct?.productDetails?.discountedPrice}</span>
                   </div>
                </Link>
               </div>
               <div className="action_btn_cont">
                   <PrimaryBtn handleBtn={() => setShowModal(true)} label="Set Price" />
               </div>
                
           </RecentEnqProduct>
           }
            </HorizontalChatOption>
           
            <ChatBubbleComp>
            {
                    convo.length? 
                    convo.map((msg, i) => {
                        return (
                            <Message key={i} msg={msg} user1={user1} />
                        )
                    })

                    : null
                }
            </ChatBubbleComp>
            <ChatInputBar onSubmit={handleSendMessage} type="submit">
                <div className='inputoption_plusicon'>
                <AiOutlinePlus className='input_option_icon' size={18} color="#fff" />
                </div>

                <ChatInputField required="true" value={textMessage} onChange={(e) => setTextMessage(e.target.value)}
                placeholder='Type a message...'>

                </ChatInputField>
                <div className='input_option_rhs'>
                <FaRegSmile className='input_option_icon_emoji' size={18} color="#3A3A3A" />
                <IoNavigate onClick={handleSendMessage} className='input_option_icon' size={18} color="#fff" />
                </div>
            </ChatInputBar>
        </ChatDetailWrap>
    )
}

export default ChatDetailItem

const ChatDetailWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.text};

`

const HorizontalChatOption = styled.div`
    display: flex;
    background: ${({ theme }) => theme.background};
    height: 5rem;
    padding: 0rem 1rem;
    position: relative;
`
const ChatPerson = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    


    .chat_person {
        display: flex;
        align-items: center;
    }  

    .chat_person img {
        width: 40px;
        height: 40px;
        border-radius: 100%;

    }
    .name_seen__box {
        display: flex;
        flex-direction: column;
        padding-left: 0.6rem;
        height: 100%;
        justify-content: space-between;
    }
    .chat_per_name {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 21px;
        color: ${({theme}) => theme.text}
    }
    .chat_last_seen {
        font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 10px;
line-height: 16px;
color: ${({theme}) => theme.text}
    }

    .chat_count {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({theme}) => theme.text};
        font-size: 0.8rem;
        background: #F73859;
        width: 20px;
        height: 20px;
        border-radius: 100%;
    }
`
const ChatOptions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 15%;

    @media (max-width: 768px) {
        width: 35%;
    }

    .chat_option_icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--white);
        padding: 0.5rem;
        border-radius: 100%;
    }
`
const ChatBubbleComp = styled.div`
    
    background: ${({theme}) => theme.body};
    height: calc(90vh - 200px);
    overflow-y: auto;
    padding: 0.5rem;
    
  ::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
`
const ChatInputBar = styled.form`
    display: flex;
    width: 100%;
    height: 5rem;
    background: ${({ theme }) => theme.background};
    border-top: 1.5px solid var(--font-PG);

    @media(max-width: 768px){

    }
    .input_option_icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--p-red);
        padding: 0.5rem;
        border-radius: 100%;
    }

    .inputoption_plusicon {
        display: flex;
        width: 15%;
        align-items: center;
        justify-content: center;
    }

    .input_option_rhs {
        display: flex;
        align-items:center;
        justify-content: space-evenly;
        width: 15%;

        @media (max-width: 768px){
            width: 25%;
            justify-content: space-between;
            padding-right: 0.4rem;
        }
    }
`

const ChatInputField = styled.input`
    width: 80%;
    border: none;
    outline: none;
    background: ${({ theme }) => theme.background};
    margin-left: 0.4rem;
    color: ${({ theme }) => theme.text};

    :focus {
        outline: none;
        border: none;
    }
`
const MessageItem = styled.div`
    display: flex;
    background: ${({theme}) => theme.accent};
    border-radius: 20px;
    padding: 0 0.5rem;
    align-items: center;
    width: fit-content;
    right: 1rem;
    margin: 10px;
    margin-left: 60%;
    /* position: absolute; */

    img {
        display: none;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        margin-right: 5px;
    }

    .status {
        font-size: 8px;
        float: bottom;
        display: none;
    }

`

const RecentEnqProduct = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    justify-content: space-between;
    background: ${({theme}) => theme.background100};
    top: 4rem;
    left: 0;
    box-sizing: border-box;
    align-items: center;
    .product_container  {
        display: flex;
        align-items: center;

        .product_img_cont {
            display: flex;
            width: 2rem;
            height: 2rem;
            margin: 5px;

            img {
                border-radius: 10px;
                object-fit: cover;
                width: 100%;
                height: 100%;

            }
        }

        .product_det {
            display: flex;
            flex-direction: column;
        }
    }

    .link {
        text-decoration: none;
        color: ${({theme}) => theme.text};

    }
`
const ModalWrap = styled.div`
  display: flex;
  flex-direction: column;

  label, span {
    font-size: 0.8rem;
    color: ${({theme}) => theme.text};

  }

  select {
    margin-bottom: 0.5rem;
  }

  #price {
    border: none;
    outline: none;
    :focus {
      outline: none;
    }
  }

  .applybtn_cont {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    justify-content: space-between;

    
  }

  .applybtn {
    border: none;
    outline: none;
    font-size: 0.8rem;
    background: ${({theme}) => theme.accent};
    width: fit-content;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    color: ${({theme}) => theme.text};
  }
`